<template>
  <vx-card title="Cumplimiento por validación">
    <p class="gw-bajada">
      Tiempos de resolución por tipo de validación. Se informan la mediana y
      el percentil 90 en lugar del promedio: unos pocos casos muy largos
      desplazan el promedio y dejan de representar el caso habitual. La mediana
      corresponde al caso típico y el percentil 90, al 10 % de casos más
      lentos. Solo se incluyen las validaciones ya cerradas.
    </p>

    <table v-if="hayDatos" class="gw-tabla">
      <thead>
        <tr>
          <th class="gw-col-val">Validación</th>
          <th class="gw-num gw-col-n">Validaciones cerradas</th>
          <th class="gw-num gw-col-pct">Dentro del plazo</th>
          <th class="gw-num gw-col-t">Mediana</th>
          <th class="gw-num gw-col-t">Percentil 90</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="fila in filas" :key="fila.validacion">
          <td>{{ etiquetaValidacion(fila.validacion) }}</td>
          <td class="gw-num">{{ fila.total }}</td>
          <td class="gw-num">
            <span :class="fila.porcentaje_cumplimiento < meta ? 'gw-bajo' : 'gw-ok'">
              {{ fila.porcentaje_cumplimiento }}%
            </span>
            <span class="gw-detalle">{{ fila.dentro_de_ans }} de {{ fila.total }}</span>
          </td>
          <td class="gw-num">{{ tiempoLegible(fila.mediana_minutos) }}</td>
          <td class="gw-num gw-p90">{{ tiempoLegible(fila.p90_minutos) }}</td>
        </tr>
      </tbody>
    </table>
    <p v-else class="gw-sin-datos">
      No hay validaciones cerradas en este periodo. Las validaciones en curso
      no se incluyen, ya que su tiempo de resolución aún no es definitivo.
    </p>
  </vx-card>
</template>

<script>
import slaFormat from "../../mixins/slaFormat";

export default {
  name: "SlaDistributionTable",
  mixins: [slaFormat],
  props: {
    distribucion: { type: Array, default: () => [] },
    meta: { type: Number, default: 65 },
  },

  computed: {
    filas() {
      return this.distribucion;
    },
    hayDatos() {
      return this.distribucion.length > 0;
    },
  },
};
</script>

<style scoped>
.gw-bajada {
  font-size: 12px;
  color: #9a9a9a;
  margin: -6px 0 16px;
  max-width: 72ch;
}
.gw-tabla {
  width: 100%;
  max-width: 980px;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 13px;
}
.gw-tabla th {
  text-align: left;
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9a9a9a;
  border-bottom: 1px solid #ececec;
  padding: 8px 10px;
  vertical-align: bottom;
}
/* El encabezado tiene que alinearse como su columna. Sin esto los titulos
   quedaban a la izquierda y las cifras a la derecha, separadas por medio
   ancho de pantalla, y la tabla parecia incompleta. */
.gw-tabla th.gw-num {
  text-align: right;
}
/* Anchos fijos para que las cifras no se vayan al otro extremo de la
   pantalla en monitores anchos. */
.gw-col-val { width: 30%; }
.gw-col-n   { width: 16%; }
.gw-col-pct { width: 18%; }
.gw-col-t   { width: 18%; }
.gw-tabla td {
  padding: 11px 10px;
  border-bottom: 1px solid #f4f4f4;
  color: #3b3b3b;
}
.gw-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.gw-bajo {
  color: #c0392b;
  font-weight: 600;
}
.gw-ok {
  color: #2e7d52;
  font-weight: 600;
}
.gw-detalle {
  display: block;
  font-size: 11px;
  color: #9a9a9a;
}
.gw-p90 {
  color: #6b6b6b;
}
.gw-sin-datos {
  font-size: 12px;
  color: #9a9a9a;
  max-width: 72ch;
}
</style>
